import axios from "axios"


export async function llmAPI(message){
    const options={method:"POST",data:{prompt:message}, url:"https://2gsnyaloleib4xmrl5uhfwkd7i0dedcn.lambda-url.eu-north-1.on.aws/"}
    const res= await axios(options)
    return res.data
}


